import { GET_INFO_FROM_URL, SET_ERROR } from '../actions';
import TokenData from '../components/common/TokenData';

const initialDefaultState = {
  queryInfo: null,
  tokenData: new TokenData(''),
  errorFlag: null,
  description: null
};

const initial = (state = initialDefaultState, action) => {
  switch (action.type) {
    case GET_INFO_FROM_URL:
      return {
        ...state,
        queryInfo: action.queryInfo,
        tokenData: action.tokenData,
        errorFlag: action.errorFlag,
        description: action.description
      };
    default:
      return state;
    case SET_ERROR:
      return {
        ...state,
        errorFlag: action.errorFlag,
        description: action.description
      };
  }
};

export default initial;
